import React from 'react';
import Navbar from '../../components/Layouts/Navbar';
import Footer from '../../components/Layouts/Footer';
import PageSeo from '../../components/Common/PageSeo';
import SubscribeStyleOne from '../../components/Common/SubscribeStyleOne';
import MailServerHeader from '../../components/ManagedServices/MailServer/MailServerHeader';
import MailServerBenefits from '../../components/ManagedServices/MailServer/MailServerBenefits';
import MailServerIncluded from '../../components/ManagedServices/MailServer/MailServerIncluded';
import MailServerAudiences from '../../components/ManagedServices/MailServer/MailServerAudiences';
import MailServerProcess from '../../components/ManagedServices/MailServer/MailServerProcess';
import MailServerTrust from '../../components/ManagedServices/MailServer/MailServerTrust';
import MailServerPricing from '../../components/ManagedServices/MailServer/MailServerPricing';
import MailServerFaq from '../../components/ManagedServices/MailServer/MailServerFaq';
import MailServerCta from '../../components/ManagedServices/MailServer/MailServerCta';
import ManagedServicesBlogPosts from '../../components/ManagedServices/ManagedServicesBlogPosts';
import { fetchBlogPostsForMailServer } from '../../lib/blogApi';
import { useTranslations } from '../../locales/useTranslations';
import { useRouter } from 'next/router';

export const MANAGED_SERVICES_MAIL_PATH = '/managed-services/business-mail/';

const ManagedServicesMailServerPage = ({ relatedBlogPosts = [] }) => {
  const { t } = useTranslations();
  const { locale } = useRouter();
  const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

  return (
    <>
      <PageSeo
        title={t('managedServices_mailServer_page_title')}
        description={t('managedServices_mailServer_page_description')}
        canonical={`${baseUrl}${MANAGED_SERVICES_MAIL_PATH}`}
        openGraph={{
          url: `${baseUrl}${MANAGED_SERVICES_MAIL_PATH}`,
          title: t('managedServices_mailServer_page_title'),
          description: t('managedServices_mailServer_page_description'),
          images: [
            {
              url: `${baseUrl}/images/simplify-data.png`,
              width: 1200,
              height: 1200,
              alt: t('managedServices_mailServer_header_title'),
              type: 'image/jpeg',
            },
          ],
          siteName: 'Simplify Data',
          locale: locale === 'en' ? 'en_US' : 'de_DE',
          type: 'website',
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: t('managedServices_mailServer_page_keywords'),
          },
        ]}
        additionalLinkTags={[
          {
            rel: 'alternate',
            hrefLang: 'de',
            href: `https://simplify-data.de${MANAGED_SERVICES_MAIL_PATH}`,
          },
          {
            rel: 'alternate',
            hrefLang: 'en',
            href: `https://simplify-data.com${MANAGED_SERVICES_MAIL_PATH}`,
          },
        ]}
      />
      <Navbar />
      <MailServerHeader />
      <MailServerBenefits />
      <MailServerIncluded />
      <MailServerAudiences />
      <MailServerProcess />
      <MailServerTrust />
      <MailServerPricing />
      <MailServerFaq />
      <MailServerCta />
      <ManagedServicesBlogPosts
        posts={relatedBlogPosts}
        badgeKey="managedServices_mailServer_blog_badge"
        titleKey="managedServices_mailServer_blog_title"
        subtitleKey="managedServices_mailServer_blog_subtitle"
        ctaKey="managedServices_mailServer_blog_cta"
      />
      <SubscribeStyleOne />
      <Footer />
    </>
  );
};

export default ManagedServicesMailServerPage;

export async function getStaticProps({ locale }) {
  try {
    const relatedBlogPosts = await fetchBlogPostsForMailServer(locale || 'de', 6);
    return {
      props: { relatedBlogPosts },
      revalidate: 3600,
    };
  } catch {
    return {
      props: { relatedBlogPosts: [] },
      revalidate: 600,
    };
  }
}
